var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27.857,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    strokeWidth: 2,
    d: "m17.142 8.572-5.714 5.357 5.714 5.358"
  })));
};
export default SvgBack;